import { base64StringToBlob } from 'shared';

export class S3Net {
  static putSignedDataUrl = async (url: string, dataUrl: string, contentType: string) =>
    fetch(url, { method: 'PUT', headers: { 'Content-Type': contentType }, body: await base64StringToBlob(dataUrl) });
}
